import { REACT_APP_API_ISF, REACT_APP_API_TSDA } from 'src/data/config';

const apiConfig = {
  appConfig: {
    api: `http://3.130.152.114:8000`,

    apietmf: `${process.env.REACT_APP_API_ETMF}/etmf`,

    apictms: `${process.env.REACT_APP_API_CTMS}/ctms`,

    apiutils: `${process.env.REACT_APP_API_CTMS}`,

    apisysadmin: `${process.env.REACT_APP_SYSADMIN_API}/sysAdmin`,

    apiisf: `${REACT_APP_API_ISF}/isf`,

    apitsda: `${REACT_APP_API_TSDA}/tsda`
  }
};

export default apiConfig;
